import { getCollapsiblePanelStyles } from '@bingads-webui-campaign-react/display-plus-native-ads';

export const getAdGroupStepStyles = (components, theme) => ({
  collapsiblePanel: getCollapsiblePanelStyles(components, theme),
  container: {
    marginTop: 10,
  },
  reachEstimate: {
    height: '100%',
    top: 111,
    position: 'sticky',
  },
  reachEstimationError: {
    marginBottom: 12,
  },
});
